import { createContext } from 'react';

/**
 * True while a PaginatedSelect has its "show full names" toggle switched on.
 * Option labels read it to decide whether to truncate themselves.
 * Lives in its own module so option builders can consume it without importing
 * PaginatedSelect back.
 */
const LabelExpandContext = createContext(false);

export default LabelExpandContext;
